import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Flag: FunctionalComponent<IIconProps> = ({ width = '24', height = '24', fill = '#333' }) => {
  return (
    /*@ts-ignore*/
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M7.00006 5C6.44778 5 6.00006 5.44772 6.00006 6V20C6.00006 20.5523 5.55235 21 5.00006 21C4.44778 21 4.00006 20.5523 4.00006 20V6C4.00006 4.34315 5.34321 3 7.00006 3H19.5839C20.2467 3 20.7839 3.53726 20.7839 4.2C20.7839 4.47249 20.6912 4.73686 20.521 4.94963L17.2807 9L20.521 13.0504C20.935 13.5679 20.8511 14.323 20.3336 14.737C20.1208 14.9073 19.8564 15 19.5839 15H9.00006C8.44778 15 8.00006 14.5523 8.00006 14C8.00006 13.4477 8.44778 13 9.00006 13H17.9194L15.4691 9.93704C15.0308 9.38921 15.0308 8.61079 15.4691 8.06296L17.9194 5H7.00006Z"
        fill={fill}
      />
    </svg>
  );
};

export default Flag;
